export type GraphQLReadableData = {
  userMessage?: unknown;
  message?: unknown;
  code?: number;
  keyValue?: Record<string, unknown>;
  fields?: Array<{ kind?: string; path?: string }>;
  errorCode?: string;
  userMessageSeverity?: string;
};

export type GraphQLErrorLike = {
  message?: string;
  extensions?: {
    code?: string | number;
    readableData?: GraphQLReadableData;
  };
};

export const uniqueGraphQLErrorsByMessage = <T extends { message?: string }>(
  errors: readonly T[],
) => {
  const seen = new Set<string>();
  return errors.filter((error) => {
    const key = error.message ?? '';
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
};

export const getGraphQLErrorMessage = (
  translateBackendString: (translatedObject: unknown) => string,
  gqlError: GraphQLErrorLike | undefined | null,
  fallback?: string,
) => {
  if (!gqlError) return undefined;

  const readableData = gqlError.extensions?.readableData;
  const translatedUserMessage = translateBackendString(
    readableData?.userMessage,
  );
  if (translatedUserMessage) return translatedUserMessage;

  const readableMessage = readableData?.message;
  if (typeof readableMessage === 'string' && readableMessage !== '') {
    return readableMessage;
  }
  const translatedReadableMessage = translateBackendString(readableMessage);
  if (translatedReadableMessage) return translatedReadableMessage;

  return fallback || gqlError.message || undefined;
};
